import { createContext } from "preact";
import { useContext } from "preact/hooks";
import type { AppContextValue } from "./types.js";

export const AppContext = createContext<AppContextValue | null>(null);

export function useApp() {
  const value = useContext(AppContext);
  if (!value) throw new Error("useApp must be used inside AppContext.Provider");
  return value;
}
